import { useContext } from "react";
import { CustomerContext } from "../../providers";
import { Button } from "../tailwind/button";
import { Field, Fieldset } from "../tailwind/fieldset";
import { Text } from "../tailwind/text";

export const QTrack = () => {
  const { customer, shop, integrations } = useContext(CustomerContext);
  const titleClasses = "font-bold";
  const fieldClasses = "mb-2";

  return (
    <div className="relative">
      <Fieldset>
        {integrations.shopify && integrations.klaviyo && (
          <Field className={fieldClasses}>
            <Text className={titleClasses}>
              Make the most our of WhatsApp by collecting purchase intents
            </Text>
            <Text className="my-3">Install the free Shopify App</Text>
            <Button
              color="secondaryButton"
              className="mt-2 mb-5"
              onClick={() =>
                window.open("https://apps.shopify.com/quanticfy", "_blank")
              }
            >
              Install the App
            </Button>
            <Text className="italic text-xs">
              Thanks to our partnership, The Quantic Factory app is free and
              takes just a few clicks to set up.
            </Text>
            <Text className="italic text-xs">
              A quick 5-minute onboarding will guide you through the essential
              features.
            </Text>
          </Field>
        )}
        {!integrations.shopify && (
          <Field className={fieldClasses}>
            <Text className={titleClasses}>It's not available yet :(</Text>
            <Text>
              As of now, when only support event tracking for Shopify brands.
            </Text>
          </Field>
        )}
      </Fieldset>
    </div>
  );
};
